
import { Component, Vue } from 'vue-property-decorator'
import { useCultureSubsidyStore } from '@/stores/cultureSubsidy'
import { AdminSection, AlertSeverity } from '../types'
import StatusBadge from '../components/StatusBadge.vue'
import SectionPills from '../components/SectionPills.vue'
import ProductsPanel from '../caretaker/ProductsPanel.vue'
import OperationsPanel from '../caretaker/OperationsPanel.vue'
import { SupervisedCaretaker } from '../types'

const SECTIONS: AdminSection[] = ['supervision', 'alerts', 'catalog']

@Component({
  name: 'CultureSubsidyAdmin',
  components: {
    StatusBadge,
    SectionPills,
    ProductsPanel,
    OperationsPanel
  }
})
export default class extends Vue {
  store = useCultureSubsidyStore()

  get section(): AdminSection {
    const query = this.$route.query.section as AdminSection
    return SECTIONS.includes(query) ? query : 'supervision'
  }

  get navItems() {
    return [
      { id: 'supervision', label: String(this.$t('cultureSubsidy.admin.nav.supervision')) },
      { id: 'alerts', label: String(this.$t('cultureSubsidy.admin.nav.alerts')), badge: this.store.alerts.length },
      { id: 'catalog', label: String(this.$t('cultureSubsidy.admin.nav.catalog')) }
    ]
  }

  get kpis() {
    const list = this.store.supervised
    const active = list.filter(item => item.status === 'active').length
    const blocked = list.filter(item => item.status === 'blocked').length
    const reserve = list.reduce((sum, item) => sum + item.currentReserve, 0)
    return [
      { label: this.$t('cultureSubsidy.admin.kpiActive'), value: `${active} / ${list.length}` },
      { label: this.$t('cultureSubsidy.admin.kpiBlocked'), value: String(blocked) },
      { label: this.$t('cultureSubsidy.admin.kpiReserve'), value: this.$n(reserve, 'currency') },
      { label: this.$t('cultureSubsidy.admin.kpiAlerts'), value: String(this.store.alerts.length) }
    ]
  }

  get alertGroups() {
    const severities: AlertSeverity[] = ['critical', 'watch', 'info']
    return severities.map(severity => ({
      severity,
      items: this.store.alerts.filter(alert => alert.severity === severity)
    }))
  }

  created(): void {
    this.store.loadAdmin()
  }

  go(section: string): void {
    this.$router.replace({ query: { section } }).catch(() => undefined)
  }

  selectCaretaker(row: SupervisedCaretaker): void {
    this.store.selectAdminCaretaker(row.id)
  }

  tagType(severity: AlertSeverity): string {
    if (severity === 'critical') return 'danger'
    if (severity === 'watch') return 'warning'
    return 'info'
  }

  async reset(): Promise<void> {
    await this.store.resetDemo()
    await this.store.loadAdmin()
    this.$message.success(this.$t('cultureSubsidy.resetDone') as string)
  }
}
